<template lang="pug" src="./article.pug"></template>
<style lang="scss" src="./article.scss" scoped></style>

<script>
import { mapGetters, mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        dropdown: false,
        resultShow: false
    }),
    validations: {
        article: {
            title: {
                required
            },
            body: {
                maxLength: function() {
                    return this.article.body.length
                }
            },
            phoneFilters: {
            }
        }
    },
    computed: {
        ...mapGetters(['type']),
        ...mapState({
            filters: state => state.clientNews.filters,
            article: state => state.clientNews.article,
            count: state => state.clientNews.count,
            clients: state => state.clientNews.clients,
            normalizePhones: state => state.clientNews.normalizePhones,
            result: state => state.clientNews.result,
            isLoaded: state => state.clientNews.isLoaded
        }),
        isDisabled: function() {
            return !!this.filters.phones.length
        },
        showPhoneEditor() {
            return this.filters.sendTo === 'selected'
        },
        messageForm() {
            return !this.showPhoneEditor || (this.normalizePhones && this.normalizePhones.success &&
                this.normalizePhones.success.length)
        },
        androidErrors() {
            return Object.entries(this.result.android.errors).map(([key, value]) => ({ key, value }))
        },
        iosErrors() {
            return Object.entries(this.result.ios.errors).map(([key, value]) => ({ key, value }))
        },
        filterPhones() {
            return this.filters.phones && this.filters.phones.split('\n').filter(it => !!it)
        }
    },
    created: function() {
        this.getClientList(this.filters.sendTo)
    },
    methods: {
        getClientList(scope) {
            this.$store.dispatch('clientNews/getClients', scope)
        },
        toggleShown() {
            this.$store.commit('clientNews/UPDATE_ARTICLE', { 'shown': !this.article.shown })
        },
        setSendTo(val) {
            this.$store.commit('clientNews/SET_SELECTION', val)

            this.getClientList(val)
        },
        setArticleField(field, val) {
            this.$store.commit('clientNews/UPDATE_ARTICLE', { [field]: val })
        },
        async sendArticle() {
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                await this.$store.dispatch('clientNews/createArticle')
                this.$store.commit('clientNews/CLEAR_ARTICLE')
                this.$store.dispatch('addMessage', {
                    message: 'createdArticle',
                    type: 'success',
                    locale: true
                })

                // this.$nextTick(() => {
                //     this.$v.$reset()
                //     this.resultShow = true
                //     setTimeout(() => {
                //         scroll(this.$refs.resultCard)
                //     }, 100)
                // })
            }
        },
        validatePhones() {
            this.resultShow = false

            if (this.$v.article.phoneFilters.$invalid) {
                this.$v.article.phoneFilters.$touch()
                return
            }

            if (!this.filterPhones.length) {
                this.$store.commit('clientNews/SET_COUNT', 0)
            }
            this.$store.dispatch('clientNews/validatePhones', this.filterPhones)
        }
    }
}
</script>
